import { Controller } from "stimulus";

// Never flips from counting down to counting up in place: the sibling show_controller.js
// reloads the page once the countdown reaches zero, and that reload re-renders this
// component fresh from the server with a corrected clock.
export default class EditorialInfoPanelComponent extends Controller {
  static targets = ["timer"];
  static values = {
    timerMs: Number,
    waiting: Boolean,
    playbackEndsAtMs: Number,
  };

  connect() {
    if (!this.timerMsValue) return;

    this.tick();
    this.timerInterval = window.setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    if (this.timerInterval) window.clearInterval(this.timerInterval);
  }

  tick() {
    const now = Date.now();

    if (this.hasTimerTarget) {
      const clampedNow = !this.waitingValue && this.playbackEndsAtMsValue ? Math.min(now, this.playbackEndsAtMsValue) : now;
      const diff = Math.abs(clampedNow - this.timerMsValue);
      this.timerTarget.textContent = this.waitingValue ? `Starts in ${this.format(diff)}` : `Started ${this.format(diff)} ago`;
    }

    if (!this.waitingValue && this.playbackEndsAtMsValue && now >= this.playbackEndsAtMsValue && this.timerInterval) {
      window.clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  format(ms) {
    const minutes = Math.floor(ms / 60000);
    if (minutes < 1) return "less than a minute";
    if (minutes === 1) return "1 minute";
    return `${minutes} minutes`;
  }
}
